import React from 'react';

/**
 * Componente para imagens otimizadas com WebP + fallback
 * Usa lazy loading por padrão (exceto para hero images)
 */
const OptimizedImage = ({ 
  src, 
  alt, 
  className = '',
  style = {},
  loading = 'lazy',
  priority = false,
  ...props 
}) => {
  // Determinar se tem versão WebP
  const baseName = src.replace(/\.[^/.]+$/, '');
  const ext = src.split('.').pop();
  const webpSrc = `${baseName}.webp`;
  
  // Se for priority (hero), não usar lazy loading
  const loadingAttr = priority ? 'eager' : loading;
  
  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <source srcSet={src} type={`image/${ext}`} />
      <img 
        src={src}
        alt={alt}
        className={className}
        style={style}
        loading={loadingAttr}
        {...props}
      />
    </picture>
  );
};

export default OptimizedImage;
